"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var react_modal_1 = __importDefault(require("react-modal"));
var __1 = require("../../..");
var react_ga4_1 = __importDefault(require("react-ga4"));
//const __view = document.getElementById("react-service-contact-form");
//(__view) && Modal.setAppElement('#react-service-contact-form');
var customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        minWidth: '50%',
        padding: '24px',
        borderRadius: '8px',
        border: '1px solid rgba(224, 224, 224, 1)',
        boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)'
    },
};
var Contact = function () {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, react_1.useState)(true), isDisabled = _b[0], setIsDisabled = _b[1];
    var _c = (0, react_1.useState)(false), modalIsOpen = _c[0], setIsOpen = _c[1];
    var _d = (0, react_1.useState)(), orderId = _d[0], setOrderId = _d[1];
    var _e = (0, react_1.useState)(), data = _e[0], setData = _e[1];
    var _f = (0, react_hook_form_1.useForm)(), handleSubmit = _f.handleSubmit, register = _f.register, setValue = _f.setValue, watch = _f.watch;
    var watchAllFields = watch();
    (0, react_1.useEffect)(function () {
        var subscription = watch(function (value, _a) {
            var name = _a.name, type = _a.type;
            (value.skype || value.telegram || value.viber || value.discord)
                ? setIsDisabled(false)
                : setIsDisabled(true);
        });
        return function () { return subscription.unsubscribe(); };
    }, [watch]);
    var onSubmit = function (data) {
        console.log(data);
        setData(data);
        axios_1.default.post("/app/order/service", data)
            .then(function (response) {
            if (response.status == 200) {
                if (__1.SETUP_LOCAL_APP) {
                    react_ga4_1.default.initialize(__1.GA_ID);
                    react_ga4_1.default.event("generate_lead", {
                        currency: "USD",
                        value: 1
                    });
                }
                setIsOpen(true);
                setOrderId(response.data.id);
            }
            //setList(response.data);
        });
    };
    (0, react_1.useEffect)(function () {
        react_modal_1.default.setAppElement('#react-service-contact-form');
        var view = document.getElementById("react-service-contact-form");
        if (view) {
            var id = view.getAttribute('data-service-item-id');
            if (id) {
                setValue("service_item_id", parseInt(id));
            }
        }
    }, []);
    function closeModal() {
        setIsOpen(false);
    }
    var renderContact = function (caption, image) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("img", { style: { marginRight: "8px" }, src: image }),
            react_1.default.createElement("span", { style: { fontSize: "14px", fontWeight: "700", lineHeight: "20px" } }, caption)));
    };
    return (react_1.default.createElement("div", { className: "wrap-service-contact-form" },
        react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit) },
            react_1.default.createElement("input", __assign({}, register("service_item_id"), { type: "hidden" })),
            react_1.default.createElement("input", __assign({}, register("discord"), { placeholder: t("page.service.contect.form.discord") })),
            react_1.default.createElement("input", __assign({}, register("viber"), { placeholder: t("page.service.contect.form.viber") })),
            react_1.default.createElement("input", __assign({}, register("telegram"), { placeholder: t("page.service.contect.form.telegram") })),
            react_1.default.createElement("input", __assign({}, register("skype"), { placeholder: t("page.service.contect.form.skype") })),
            react_1.default.createElement("button", { disabled: isDisabled }, t("page.service.contect.form.submit"))),
        react_1.default.createElement(react_modal_1.default, { isOpen: modalIsOpen, onRequestClose: closeModal, style: customStyles, contentLabel: "Example Modal" },
            react_1.default.createElement("div", { className: "purchase-wrap-content", style: { width: '100%' } },
                react_1.default.createElement("div", { className: "__wrap-caption" },
                    react_1.default.createElement("span", { className: "__caption" }, t("page.service.responce.caption")),
                    react_1.default.createElement("img", { onClick: closeModal, className: "close-modal", src: "/images/app/close.svg" })),
                react_1.default.createElement("div", { className: "__wrap-content" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "__request-text" }, t("page.service.responce.text")),
                        react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", marginTop: "24px" }, className: "" },
                            data && data.discord.trim().length > 0
                                && renderContact(data.discord, "/images/web/discord-icon-svgrepo-com.png"),
                            data && data.skype.trim().length > 0
                                && renderContact(data.skype, "/images/app/page/service/skype.svg"),
                            data && data.viber.trim().length > 0
                                && renderContact(data.viber, "/images/app/page/service/viber.svg"),
                            data && data.telegram.trim().length > 0
                                && renderContact(data.telegram, "/images/app/page/service/telegram.svg")),
                        react_1.default.createElement("div", { className: "__line" }),
                        react_1.default.createElement("div", { className: "__game-text" }, t("page.service.responce.game-text")),
                        react_1.default.createElement("a", { className: "__game-link", href: "/" },
                            t("page.service.responce.link"),
                            react_1.default.createElement("img", { src: "/images/web/icons8_arrow.png" }))),
                    react_1.default.createElement("div", { className: "__right-side" },
                        react_1.default.createElement("div", { className: "__caption" }, t("page.service.responce.caption-side")),
                        react_1.default.createElement("img", { style: { marginTop: "40px" }, src: "/images/web/icons8_check_all.png" })))))));
};
exports.default = Contact;
